import { Auth, Hub } from "aws-amplify";
import router from "@/router";
import ApiService from '@/helpers/api.service'


export function authentication() {
    const API = new ApiService()

    const user = JSON.parse(localStorage.getItem("userData"))
    Hub.listen("auth", ({ payload: { event, data } }) => {
        console.log(`Auth event: ${event}`);
        switch (event) {
            case "signIn":
                var userDetails = {
                    userName: data.username,
                    email: data.signInUserSession.idToken.payload.email,
                    jwtToken: data.signInUserSession.accessToken.jwtToken,
                    refreshToken: data.signInUserSession.refreshToken.token,
                    expirationTime: data.signInUserSession.idToken.payload.exp
                };
                localStorage.setItem("userData", JSON.stringify(userDetails));
                sessionStorage.setItem("authUser", JSON.stringify(userDetails));

                // Check for stored redirect link
                var redirectUrl = localStorage.getItem('redirectUrl');
                if(redirectUrl){
                    localStorage.removeItem('redirectUrl');
                    window.location.href = redirectUrl;
                } else {
                    router.go();
                }

                break;
            case "signOut":
                console.log("SignOut")
                sessionStorage.removeItem('authUser');
                localStorage.removeItem('userData');
                break;
        }
      });
    
    if (user) {
        const time = Date.now()
        let timenow = Math.floor(time / 1000)
        if (user.expirationTime - timenow > 0) {
            Auth.currentAuthenticatedUser()
            .then(async (user) => {
                console.log("Refreshing access and id tokens");
                let currentSession = user.signInUserSession
                console.log("Session: ", currentSession)
                user.refreshSession(currentSession.refreshToken,  (err, session) => {
                    if (err) {
                        Auth.signOut()
                        .then(() => {
                            console.log("SignOut")
                            sessionStorage.removeItem('authUser');
                            localStorage.removeItem('userData');
                            router.go()

                        }).catch(err => console.log("Error refreshing tokens: " + err));
                    } else {
                        let userData = JSON.parse(localStorage.getItem('userData'))
                        let tmp_userData = {
                            ...userData,
                            jwtToken: session.idToken.jwtToken
                        }
                        localStorage.setItem('userData',JSON.stringify(tmp_userData))
                        API.setHeaders(session.idToken.jwtToken)
                    }
                })
            })
            .catch(err => console.log("Auth.currentAuthenticatedUser(): " + err));
        } else {
            Auth.signOut()
            .then(() => {
                console.log("SignOut")
                sessionStorage.removeItem('authUser');
                localStorage.removeItem('userData');
                router.go()

            }).catch(err => console.log("Error refreshing tokens: " + err));
        }
    }
}